export default "__VITE_ASSET__kp5F5u0J__"